import { useInAppReview } from './useInAppReview';

/**
 * 앱 리뷰 유도 트리거 — 렌더 UI가 없는 헤드리스 컴포넌트.
 * 노출 조건 판정과 OS In-App Review 시트 호출은 useInAppReview가 전담하며, 이 컴포넌트는 훅을 마운트만 한다.
 */
const InAppReviewTrigger = () => {
  useInAppReview();

  return null;
};

export default InAppReviewTrigger;
